import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../services/auth.service';
import { InstitutionInfo } from '../../models/institution-info.model';
import { InstitutionInfoService } from '../../services/institution-info.service';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-vacantbededit',
  templateUrl: './vacant-bed-edit.component.html',
  styleUrls: ['./vacant-bed-edit.component.css']
})
export class VacantBedEditComponent implements OnInit {

  institutionInfo: InstitutionInfo;

  isUpdating = false;

  constructor(private alertService: AlertService, private authService: AuthService,
    private institutionInfoService: InstitutionInfoService)
  { }

  ngOnInit() {
    let id = this.authService.currentUser.institutionId;

    this.institutionInfoService.getInstitutionInfo(id)
      .subscribe(info => {
        this.institutionInfo = info;
      });
  }

  clearMessage() {
    this.alertService.resetStickyMessage();
  }

  update() {
    this.clearMessage();
    this.isUpdating = true;

    this.institutionInfoService.updateInstitutionInfo(this.institutionInfo)
      .subscribe(info => {
        this.institutionInfo = info;
        setTimeout(() => {
          this.isUpdating = false;
        }, 500);
      });
  }
}
